<template>
<!-- eslint-disable max-len -->
<list-page
  name="Section"
  use="_id"
  :display="display"
  page-prefix="/blade/challenges"
  :fetch="getData"
  :remove="deleteChallenge"
></list-page>
</template>

<script>
import { mapActions } from 'vuex';

import ListPage from '../../ui/pages/ListPage';

export default {
  components: {
    ListPage
  },
  data() {
    return {
      teamDecisionsById: {},
      rolesById: {},
    };
  },
  methods: {
    ...mapActions([
      'getChallenges',
      'getTeamDecisions',
      'getRoles',
      'deleteChallenge',
    ]),
    async getData() {
      const [challenges, teamDecisions, roles] =
        await Promise.all([this.getChallenges(), this.getTeamDecisions(), this.getRoles()]);

      const hashById = (acc, item) => {
        acc[item._id] = item;
        return acc;
      };

      this.teamDecisionsById = teamDecisions.reduce(hashById, {});
      this.rolesById = roles.reduce(hashById, {});
      return challenges;
    },
    display({
      name: challengeName,
      updated,
      startingTeamDecision,
      switchRoles,
    }) {
      const date = updated && new Date(updated);
      const dateString = date && `(edited ${date.toLocaleDateString()} ${date.toLocaleTimeString()})` || '';
      const startTD = this.teamDecisionsById[startingTeamDecision];
      const decisionString =
        startingTeamDecision
          ? ` START: ${(startTD || {}).name || 'BROKEN LINK'}`
          : '(No starting decision)';
      let roleString = '(No role switch)';
      if (switchRoles && switchRoles.length > 0) {
        const fromRoleString =
          switchRoles[0].fromRole
            ? (this.rolesById[switchRoles[0].fromRole] || {}).name || 'BROKEN LINK'
            : '(No from role)';
        const toRoleString =
          switchRoles[0].toRole
            ? (this.rolesById[switchRoles[0].toRole] || {}).name || 'BROKEN LINK'
            : '(No to role)';
        roleString = `(${fromRoleString} --> ${toRoleString})`;
      } else if (startTD != null && startTD.decisions != null
        && startTD.decisions.length > 0 && startTD.decisions[0].role != null) {
        const startTDRole = this.rolesById[startTD.decisions[0].role];
        if (startTDRole != null) {
          roleString = `(${startTDRole.name})`;
        }
      }
      return `${challengeName} ${dateString}
        ${decisionString}
        ${roleString}`;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/ChallengesList.vue